import { render } from "./ServicosDetalheView.vue?vue&type=template&id=452b005a"
import script from "./ServicosDetalheView.vue?vue&type=script&lang=js"
export * from "./ServicosDetalheView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__